import axios from 'axios';

axios.defaults.baseURL = 'https://appape.xyz/api';
axios.defaults.headers.common['AppToken'] = 'FSIZbe0Fr2PQ3zgEzDL6qxjShmpc2hsPGaTv6W9VZ1Yje7uVa7LPL1FkZVMgzfgv';
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

